import { useNavigate } from "react-router-dom";
import { useDialog } from "@shared/features/dialog/useDialog";
import { useSupport } from "../../SupportContext";
import { useSupportSheet } from "../../hooks/useSupportSheet";
import { useIsSupportPage } from "../../hooks/useIsSupportPage";
import { SupportSearchForm } from "./SupportSearchForm";
import { Article } from "../../support.types";

export function SupportSearchFormContainer() {
  const { closeDialog } = useDialog();

  const navigate = useNavigate();

  const isSupportPage = useIsSupportPage();

  const { openSheet } = useSupportSheet();

  const { articles, categories } = useSupport();

  const handleArticleResultClick = (article: Article) => {
    closeDialog("supportSearch");

    isSupportPage ? navigate(`/support/${article.id}`) : openSheet(article.id);
  };

  return (
    <SupportSearchForm
      articles={articles}
      categories={categories}
      onArticleResultClick={handleArticleResultClick}
    />
  );
}

export default SupportSearchFormContainer;
